import { RadiusCorner } from '../../utils/editorReactIcons';
export { RadiusCorner };
export default RadiusCorner;
